import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
const EditButton = (props) => {
return (
    <span onClick={props?.onClick}>
      <FontAwesomeIcon icon={['fas', 'pencil']} size="sm" />
    </span>
  );
};

export default EditButton;
